import { render, staticRenderFns } from "./RankItem.vue?vue&type=template&id=43c8dab2&scoped=true&lang=pug&"
import script from "./RankItem.vue?vue&type=script&lang=js&"
export * from "./RankItem.vue?vue&type=script&lang=js&"
import style0 from "./RankItem.vue?vue&type=style&index=0&id=43c8dab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c8dab2",
  null
  
)

export default component.exports